import { getCreditCardType } from 'shared/utils'

import Icon from '@components/Icon'

import { initCreditCardAddView, selectCreditCardBrand } from '../actions'
import { creditCardFormStateSelector } from '../../selectors'

const selection = ['visa', 'amex', 'mastercard']

const Brand = ({ brand, onSelect, selectedBrand, iframeName }) => (
    <li className="d-flex flex-column align-items-center">
        <label htmlFor={`credit-card-${brand}`}>
            <Icon type={getCreditCardType(brand)} size="lg" withShadow />
        </label>
        <input
            type="radio"
            id={`credit-card-${brand}`}
            name="brand"
            checked={selectedBrand === brand}
            onChange={() => onSelect(iframeName, brand)}
        />
    </li>
)

class CreditCardBrandSelect extends Component {
    componentDidMount() {
        const { initCreditCardAddView } = this.props

        initCreditCardAddView()
    }

    render() {
        const { selectedBrand, selectCreditCardBrand, iframeName } = this.props

        return (
            <div className="card-brand-selection">
                <ul className="brand-list">
                    {selection.map((brand, index) => (
                        <Brand
                            brand={brand}
                            key={index}
                            iframeName={iframeName}
                            selectedBrand={selectedBrand}
                            onSelect={selectCreditCardBrand}
                        />
                    ))}
                </ul>
                {selectedBrand === null && (
                    <p>
                        {' '}
                        <T>dashboard.label.select.card.type</T>{' '}
                    </p>
                )}
            </div>
        )
    }
}

const mapDispatchToProps = {
    initCreditCardAddView,
    selectCreditCardBrand,
}

export default connect(creditCardFormStateSelector, mapDispatchToProps)(CreditCardBrandSelect)
